module.exports = __webpack_public_path__ + "img/Lark20201202-143318.1766306608134.gif";